<template>
    <div class="invoice">
        <div class="refund-container">
            <div class="d-flex-between-center">
                <label class="m-d-0">{{ pembayaran }}</label>
                <label class="m-d-0">Rp {{ nominal | decimal }}</label>
            </div>
            <div class="d-flex">
                <SODropdown
                    :id="'dropdown-refund-kas'"
                    :items="refundOptions"
                    :title="getSelectedAkun"
                    @action="onSelectKas"
                    @update-data="renewOptions"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SODropdown from "@/so-components/global/ui/SODropdown";

export default {
    name: "RefundInput",
    props: {
        pembayaran: {
            type: String,
            required: true,
        },
        nominal: {
            type: Number,
            required: true,
        },
        selected: {
            type: String,
            required: true,
        },
    },
    components: {
        SODropdown,
    },
    data() {
        return {
            refundOptions: [],
        };
    },
    async mounted() {
        await this.init();
    },
    computed: {
        ...mapGetters("metaModule", {
            getAkun: `getAkunKeuanganGlobal`,
        }),
        getSelectedAkun() {
            let akun = this.getAkun.find((akun) => akun.idakun === this.selected);

            return akun?.nama_akun || "Pilih Akun";
        },
    },
    methods: {
        ...mapActions({
            fetchAkun: `metaModule/fetchAkunKeuanganGlobal`,
        }),
        async init() {
            await this.fetchAkun();
            await this.setRefundOptions();
        },
        setRefundOptions() {
            this.refundOptions = [];
            this.getAkun.forEach((akun) => {
                this.refundOptions.push({
                    title: akun.nama_akun,
                    selected: false,
                    action: akun.idakun,
                });
            });
        },
        onSelectKas(val) {
            this.$emit("onSelect", val);
        },
        renewOptions(val) {
            this.refundOptions = val;
        },
    },
};
</script>
<style scoped>
.refund-container {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 8px 16px;
}
</style>
